import React, { useMemo } from "react";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { useGoogleMapsLoader } from "@/hooks/useGoogleMapsLoader";
import Loader from "@/components/ui/loader";

const mapContainerStyle = {
  width: "100%",
  height: "100%",
};

const PortMap = ({ port }) => {
  const { isLoaded } = useGoogleMapsLoader();

  const coords = useMemo(() => {
    if (!port) return { lat: 22.5937, lng: 82.9629 };
    if (port.coordinates && port.coordinates.lat && port.coordinates.lng) {
      return {
        lat: parseFloat(port.coordinates.lat),
        lng: parseFloat(port.coordinates.lng)
      };
    }
    if (port.latitude && port.longitude) {
      return {
        lat: parseFloat(port.latitude),
        lng: parseFloat(port.longitude)
      };
    }
    return { lat: 22.5937, lng: 82.9629 };
  }, [port]);

  if (!isLoaded) {
    return (
      <div className="w-full h-96 flex items-center justify-center bg-muted/20 border rounded-lg">
        <Loader />
      </div>
    );
  }

  return (
    <div className="w-full h-96 rounded-lg overflow-hidden border border-border">
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={coords}
        zoom={12}
        options={{
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
        }}
      >
        <Marker 
          position={coords} 
          title={port?.name || "Port Location"} 
        />
      </GoogleMap>
    </div>
  );
};

export default PortMap;